// extracted by mini-css-extract-plugin
module.exports = {"footer_control":"reviewCriteria_footer_control__UFSyN","content":"reviewCriteria_content__1_eAJ","note":"reviewCriteria_note__6YISw"};